import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { CrmStatus, FormRouteParams, FormRoutePreview, RouteCode } from "./dtos";

const ROUTES_SERVICE = `${Constants.API_URL}/bedrock/routes`;

// These endpoints answer with the error envelope; callers read its `error` code, so the body is rethrown whole
export class FormRouteServices {
  @scCatchServiceException(true)
  static async getCodes(): Promise<{ content: RouteCode[] }> {
    const { data } = await axios.get<{ content: RouteCode[] }>(`${ROUTES_SERVICE}/codes`);
    return data;
  }

  @scCatchServiceException(true)
  static async createCode(label: string): Promise<RouteCode> {
    const { data } = await axios.post<RouteCode>(`${ROUTES_SERVICE}/codes`, { label });
    return data;
  }

  @scCatchServiceException(true)
  static async getCrmStatus(): Promise<{ content: CrmStatus[] }> {
    const { data } = await axios.get<{ content: CrmStatus[] }>(`${ROUTES_SERVICE}/crm_status`);
    return data;
  }

  @scCatchServiceException(true)
  static async preview(target: "forms", ref: string, params: FormRouteParams): Promise<FormRoutePreview> {
    const { data } = await axios.post<FormRoutePreview>(`${ROUTES_SERVICE}/preview`, { target, ref, params });
    return data;
  }
}
